module.exports = __webpack_public_path__ + "img/archery_tech_Normal_ua.61a4ef0c.webp";